/* eslint-disable */
import PropTypes from "prop-types";
import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Alert, Snackbar } from "@mui/material";
import { apiUrl, getRequest, postRequest } from "../utils/services";

export const AuthContext = createContext();
/* eslint-disable */
export const AuthContextProvider = ({ children }) => {
  const navigate = useNavigate();

  const [user2, setUser] = useState(null);
  const [token, setToken] = useState("");
  const [settings, setSettings] = useState(false);
  const [toats, setToats] = useState({
    message: "",
    open: false,
    type: "success",
  });

  let user = JSON.parse(localStorage.getItem("User"));
  const [registerError, setRegisterError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [registerInfo, setRegisterInfo] = useState({
    firstName: "",
    lastName: "",
    userName: "",
    email: "",
    mobileNumber: "",
    password: "",
  });

  const [loginError, setLoginError] = useState(null);
  const [isLoginLoading, setIsLoginLoading] = useState(false);
  const [loginInfo, setLoginInfo] = useState({
    email: "",
    password: "",
  });

  const [forgotPasswordError, setForgotPasswordError] = useState(null);
  const [isForgotPasswordLoading, setIsForgotPasswordLoading] = useState(false);
  const [forgotPasswordInfo, setForgotPasswordInfo] = useState({
    email: "",
    newPassword: "",
  });
  const [isNavigatetoLogin, setIsNavigateToLogin] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (user == null) {
      if (
        !location.pathname.includes("/admin/reset-password/") &&
        location.pathname !== "/admin/login" &&
        location.pathname !== "/privacy-policy" &&
        location.pathname !== "/terms-conditions" &&
        location.pathname !== "/subscription" &&
        location.pathname !== "/payment-success" &&
        location.pathname !== "/login" &&
        location.pathname !== "/admin/register" &&
        location.pathname !== "/admin/forgot-password" &&
        location.pathname !== "/admin/404" &&
        location.pathname !== "/404"
      ) {
        navigate("/login");
      }
    } else {
      if (location.pathname === "/admin/login") {
        navigate("/admin");
      }
    }
  }, [location]);

  const updateRegisterInfo = useCallback((info) => {
    setRegisterInfo(info);
  }, []);

  const updateLoginInfo = useCallback((info) => {
    setLoginInfo(info);
  }, []);

  const updateForgotPasswordInfo = useCallback((info) => {
    setForgotPasswordInfo(info);
  }, []);

  const updateForgotPasswordError = useCallback((error) => {
    setForgotPasswordError(error);
  }, []);

  const updateNavigateToLogin = useCallback((val) => {
    setIsNavigateToLogin(val);
  }, []);

  const registerUser = useCallback(
    async (e) => {
      // e.preventDefault();
      setRegisterError(null);
      if (
        !registerInfo?.email ||
        !registerInfo?.firstName ||
        !registerInfo?.lastName ||
        !registerInfo?.userName ||
        !registerInfo?.mobileNumber ||
        !registerInfo?.password
      ) {
        setRegisterError("All Fields required...");
        return;
      }

      setIsLoading(true);

      const response = await postRequest(
        `${apiUrl}/users/register`,
        JSON.stringify(registerInfo)
      );

      setIsLoading(false);
      if (response.error) {
        const err = response?.message?.error || response?.message;
        setRegisterError(err);
      }

      localStorage.setItem("User", JSON.stringify(response));

      setUser(response);
      navigate("/chat");
    },
    [registerInfo]
  );

  const loginUser = useCallback(
    async (e) => {
      e.preventDefault();
      setIsLoginLoading(true);
      setLoginError(null);
      try {
        const response = await postRequest(
          `${apiUrl}/admin/login`,
          JSON.stringify(loginInfo),
          false
        );
        setIsLoginLoading(false);
        if (!response.status) {
          const err = response.message;
          console.log("error", err);
          // console.log('response', response)
        //   return setLoginError(err);
            return setLoginError("Username or password incorrect");
        }
        
        localStorage.setItem("token", JSON.stringify(response.token));
        localStorage.setItem("User", JSON.stringify(response.user));
        setToken(response.token);
        setUser(response.user);
        navigate("/admin");
      } catch (error) {
        setLoginError("Username or password incorrect");
      }
    },
    [loginInfo]
  );

  const refreshToken = useCallback(async () => {
    setIsLoginLoading(true);
    setLoginError(null);

    const response = await postRequest(
      `${apiUrl}/users/generateToken`,
      JSON.stringify({ refreshToken: user.refreshToken }),
      false
    );
    setIsLoginLoading(false);
    if (response.error) {
      const err = response?.message?.error || response?.message;
      console.log("error", err);
      return setLoginError(err);
    }

    localStorage.setItem("User", JSON.stringify(response));

    setUser(response);
  }, []);

  const authCheck = useCallback(async () => {
    const response = await getRequest(`${apiUrl}/users`, user);
    console.log("authCheck", response);
    if (response.error) {
      if (response.code === 401) {
        localStorage.removeItem("User");
        setUser(null);
        navigate("/chat/login");
      }
    }
    return response;
  }, []);

  const logoutUser = useCallback(() => {
    localStorage.removeItem("User");
    setUser(null);
    window.location.href = "/chat/login";

    // navigate("/chat/login");
  }, []);

  const getUser = async (id) => {
    if (!id) {
      return;
    }

    const response = await getRequest(`${apiUrl}/users/find/${id}`);

    if (response.error) {
      return response.error;
    }

    localStorage.setItem("User", JSON.stringify(response));
    setUser(response);
  };
  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setToats({ ...toats, open: false });
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        token,
        setUser,
        registerInfo,
        updateRegisterInfo,
        registerUser,
        registerError,
        isLoading,
        logoutUser,
        loginUser,
        updateLoginInfo,
        loginInfo,
        loginError,
        isLoginLoading,
        getUser,
        setRegisterError,
        updateForgotPasswordInfo,
        forgotPasswordError,
        forgotPasswordInfo,
        isForgotPasswordLoading,
        // forgotPasswordUpdate,
        updateForgotPasswordError,
        updateNavigateToLogin,
        isNavigatetoLogin,
        setToats,
        settings,
      }}
    >
      {children}
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        open={toats.open}
        onClose={handleSnackbarClose}
        key="topright"
        autoHideDuration={3000}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={toats.type}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {toats.message}
        </Alert>
      </Snackbar>
    </AuthContext.Provider>
  );
};

AuthContextProvider.propTypes = {
  children: PropTypes.any,
};
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};

